import { CSSProperties, useRef } from 'react';

import { useCloseMenuIfClickedOutside } from 'coreOld/hooks';
import { INavItem } from 'coreOld/types';

import DropdownNavView from './DropdownNavView';

interface IProps {
  navItems?: INavItem[];
  name?: string;
  icon?: JSX.Element;
  secondaryNav?: boolean;
  isOpen: boolean;
  toggleDropdown: (name: string) => void;
  style?: CSSProperties;
  userResources?: string[];
}

const DropdownNav = ({
  navItems,
  name,
  icon,
  secondaryNav,
  isOpen,
  toggleDropdown,
  style,
  userResources,
}: IProps) => {
  const ref = useRef(null);

  useCloseMenuIfClickedOutside(ref, isOpen, toggleDropdown);

  return (
    <DropdownNavView
      isOpen={isOpen}
      toggleDropdown={toggleDropdown}
      navItems={navItems}
      name={name}
      icon={icon}
      secondaryNav={secondaryNav}
      style={style}
      userResources={userResources}
      ref={ref}
    />
  );
};

export default DropdownNav;
